<template>
  <div class="column is-half-mobile">
    <div class="box">
      <b-tooltip :label="description" v-if="description" multilined>
        <p>
          <span class="has-text-weight-bold">{{ text }}</span>
        </p>
        {{
          hasCurrencySymbol
            ? `${payments.currencySymbol} ${formatMoney(value)}`
            : `${isNaN(value) ? "-" : value} %`
        }}
      </b-tooltip>

      <p v-else>
        <span class="has-text-weight-bold">{{ text }}</span>
        <br />
        {{
          hasCurrencySymbol
            ? `${payments.currencySymbol} ${formatMoney(value)}`
            : `${isNaN(value) ? "-" : value} %`
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

export default {
  props: ["description", "text", "hasCurrencySymbol", "value"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>
